module.exports = __webpack_public_path__ + "img/10.c284fca8.jpg";